// src/components/ui/sections/BusinessHoursSection/BusinessHoursSectionShadcn.jsx
import React from 'react';
import { Save } from 'lucide-react';

// shadcn components
import { Button } from '../../button';
import { Input } from '../../input';
import { Label } from '../../label';
import { Switch } from '../../switch';
import { Card, CardContent } from '../../card';

import { cn } from '../../../../utils/cn';

const BusinessHoursSectionShadcn = ({
  hoursForm,
  handleHoursSubmit,
  handleHourChange,
  savingHours,
  hasChanges,
  daysOfWeek,
  className = ''
}) => {
  return (
    <div className={cn('h-full flex flex-col', className)}>
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <form onSubmit={handleHoursSubmit} className="space-y-4">
          {daysOfWeek.map(({ key, label }) => {
            const dayHours = hoursForm[key] || { is_open: false, open_time: '09:00', close_time: '17:00' };

            return (
              <Card key={key}>
                <CardContent className="p-4">
                  <div className="flex items-center space-x-4">
                    <div className="w-28">
                      <Label className="font-medium">{label}</Label>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Switch
                        id={`${key}-open`}
                        checked={dayHours.is_open}
                        onCheckedChange={(checked) => handleHourChange(key, 'is_open', checked)}
                      />
                      <Label htmlFor={`${key}-open`} className="text-sm">
                        Open
                      </Label>
                    </div>

                    {dayHours.is_open && (
                      <div className="flex items-center space-x-3 flex-1">
                        <Input
                          type="time"
                          value={dayHours.open_time}
                          onChange={(e) => handleHourChange(key, 'open_time', e.target.value)}
                          className="w-auto"
                        />
                        <span className="text-muted-foreground">to</span>
                        <Input
                          type="time"
                          value={dayHours.close_time}
                          onChange={(e) => handleHourChange(key, 'close_time', e.target.value)}
                          className="w-auto"
                        />
                      </div>
                    )}

                    {!dayHours.is_open && (
                      <div className="flex-1 text-muted-foreground text-sm">
                        Closed
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </form>
      </div>

      {/* Fixed Footer with Save Button */}
      <div className="flex-shrink-0 p-6 border-t">
        <div className="flex items-center justify-end">
          <Button
            onClick={handleHoursSubmit}
            disabled={!hasChanges || savingHours}
            size="lg"
            className="shadow-lg"
          >
            {savingHours ? (
              <>
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" />
                Saving...
              </>
            ) : (
              <>
                <Save className="w-4 h-4 mr-2" />
                Save Settings
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BusinessHoursSectionShadcn;